var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ 'color': _vm.customTextColorContent ? _vm.customTextColorContent : _vm.textColor,
    'font-size': (_vm.fontSize + "px"),
    'font-family': _vm.FontContent, 
    'text-transform': _vm.data.Style.ToUpperCase ? 'uppercase' : 'none' ,
    'text-align': _vm.data.Style.TextAlign,
    'padding': !_vm.isSimulation && _vm.isDesktop ? '15px 30px 15px 30px' : '10px 15px 10px 15px' 
  })},[_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }